export enum CircuitTaggingType {
  QINQ = 'QINQ',
  SINGLE = 'SINGLE',
}

export const MIN_VLAN = 1;
export const MAX_VLAN = 4094;

export interface AccountL2VPNCircuit {
  organizationId: string;
  name: string;
  circuits: L2VPNCircuit[];
}

export interface L2VPNCircuit {
  circuitId: string;
  popName: string;
  records: L2VPNCircuitRecord[] | null;
}

export interface L2VPNCircuitRecord {
  id: string;
  circuitName: string | null;
  allocatedCustomerVlanRange: string[] | null;
  allocatedServiceVlanRange: string[] | null;
  mappings: L2VPNCircuitMapping[] | null;
}

export interface L2VPNCircuitMapping {
  customerVlans: number[]; // Multiple VLAN IDs, e.g. [200, 400, 800]
  serviceVlan: number;
  taggingType: CircuitTaggingType;
  userTerminalId: string;
}

export interface AddL2VPNToAccountDetails {
  circuitId: string;
  popName: string;
  circuitName: string;
  customerVlanRange: string; // Range format, e.g. "400-410"
  serviceVlanRange: string; // Range format, e.g. "400-410"
}

export interface AddL2VPNToTerminalDetails {
  taggingType: CircuitTaggingType;
  circuitId: string;
  circuitName: string;
  customerVlans: number[]; // Multiple VLAN IDs, e.g. [200, 400, 800]
  serviceVlan: number | 0; // Single VLAN ID, e.g. 200
}

export interface L2VPNSuggestion {
  circuitId: string;
  taggingType: CircuitTaggingType;
  customerVlanRange: string;
  serviceVlanRange: string;
}